import React from 'react';
import { ArrowRight } from 'lucide-react';
export function TerroirSection() {
  return <section className="bg-white py-[140px] overflow-hidden" data-id="element-173">
      <div className="relative max-w-[1400px] mx-auto" data-id="element-174">
        {/* Image - Left 70% */}
        <div className="w-full lg:w-[70%] h-[400px] lg:h-[600px] relative section-reveal" data-id="element-175">
          <img src="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/DJI_0263.jpg" alt="Glenlofty Terroir" className="w-full h-full object-cover lg:rounded-r-[8px]" data-id="element-176" />
        </div>

        {/* Content Box - Overlapping */}
        <div className="relative lg:absolute lg:top-1/2 lg:right-8 lg:-translate-y-1/2 w-full lg:max-w-[500px] bg-white p-8 lg:p-[60px] shadow-none lg:shadow-xl rounded-[8px] z-10 section-reveal stagger-1 mt-8 lg:mt-0" data-id="element-177">
          <span className="block font-optima font-light text-[14px] uppercase text-gold tracking-[0.15em] mb-4" data-id="element-178">
            Our Terroir
          </span>
          <h2 className="font-optima font-semibold text-[36px] md:text-[48px] text-charcoal mb-6 leading-tight" data-id="element-179">
            350 Acres Under Vine
          </h2>
          <p className="font-optima text-[20px] text-charcoal/90 leading-[1.8] mb-8" data-id="element-180">
            Located approximately 1,000 feet above sea level in the Pyrenees
            foothills, Glenlofty is a true cool-climate site by Australian
            standards. Significant diurnal variation preserves acidity and
            structure.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8 mb-8" data-id="element-181">
            {['~140 hectares under vine', '30 individual vineyard blocks', 'Low yields: 4-5 tonnes/hectare', 'Certified organic'].map((stat, i) => <div key={i} className="flex items-start" data-id="element-182">
                <div className="w-1.5 h-1.5 rounded-full bg-gold mt-2 mr-3 flex-shrink-0" data-id="element-183"></div>
                <span className="font-optima font-semibold text-[16px] text-charcoal" data-id="element-184">
                  {stat}
                </span>
              </div>)}
          </div>

          <button className="flex items-center text-gold font-semibold text-[16px] hover:underline group" data-id="element-185">
            Explore Our Vineyard
            <ArrowRight size={18} className="ml-2 transition-transform group-hover:translate-x-1" data-id="element-186" />
          </button>
        </div>
      </div>
    </section>;
}